/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Exporting_ToastInputs */



/**
* | output |
* | --- |
* | "Exporting QC results..." |
*
* @param {Style_Guide_Exporting_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_exporting_toast = /** @type {((inputs?: Style_Guide_Exporting_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Exporting_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation des resultats CQ...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export der QC-Ergebnisse...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione dei risultati del controllo qualità...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт результатов контроля качества...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Exportando resultados de control de calidad...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出质控结果……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("QC 結果をエクスポートしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गुणवत्ता नियंत्रण परिणामों का निर्यात किया जा रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportando resultados de controle de qualidade...")
	return /** @type {LocalizedString} */ ("Exporting QC results...")
});